import { BadgeApiItem, ParsedBadge } from '../../types';

/** Parse "3.25TO6.7" → min/max */
export const parseBadgeRanges = (
  badges: BadgeApiItem[]
): ParsedBadge[] => {
  return badges
    .map((badge) => {
      const [minStr, maxStr] = badge.range
        .toUpperCase()
        .split('TO')
        .map((v) => v.trim());

      const min = Number(minStr);
      const max = Number(maxStr);

      if (Number.isNaN(min) || Number.isNaN(max)) {
        return null;
      }

      return {
        ...badge,
        min,
        max,
      };
    })
    .filter(Boolean) as ParsedBadge[];
};

/** Resolve badge dynamically based on score */
export const getBadgeByScore = (
  score: number,
  badges: ParsedBadge[]
): ParsedBadge | undefined => {
  return badges.find(
    (badge) => score >= badge.min && score <= badge.max
  );
};

/** Get dynamic max score */
export const getMaxBadgeScore = (badges: ParsedBadge[]) =>
  Math.max(...badges.map((b) => b.max));

export function computeReputationBadge(
  score: number,
  badgeConfig: any[]
) {
  const parsed = parseBadgeRanges(badgeConfig);
  return getBadgeByScore(score, parsed);
}